<template>
  <MainLayout>
    <div id="contents">
      <CartList />
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from '@/layouts/MainLayout.vue';
import CartList from '@/components/cart/CartList.vue';
export default {
  name: 'CartView',
  components: {
    MainLayout,
    CartList,
  },
};
</script>
